// タイマーの前回設定時間と終了音量を、利用者単位でローカルストレージへ保存する。

import {
  CANVAS_TIMER_DEFAULT_DURATION_MS,
  CANVAS_TIMER_MAX_DURATION_MS,
  CANVAS_TIMER_MIN_DURATION_MS,
  normalizeCanvasTimerDuration,
} from "@refinement-canvas/domain";

const DURATION_KEY = "refinement-canvas:timer:duration-ms";
const VOLUME_KEY = "refinement-canvas:timer:volume";
const DEFAULT_VOLUME = 0.7;

export function loadCanvasTimerDuration(): number {
  try {
    const durationMs = Number(window.localStorage.getItem(DURATION_KEY));
    if (
      !Number.isFinite(durationMs) ||
      durationMs < CANVAS_TIMER_MIN_DURATION_MS ||
      durationMs > CANVAS_TIMER_MAX_DURATION_MS
    ) {
      return CANVAS_TIMER_DEFAULT_DURATION_MS;
    }
    return normalizeCanvasTimerDuration(durationMs);
  } catch {
    return CANVAS_TIMER_DEFAULT_DURATION_MS;
  }
}

export function saveCanvasTimerDuration(durationMs: number): void {
  try {
    window.localStorage.setItem(DURATION_KEY, String(normalizeCanvasTimerDuration(durationMs)));
  } catch {
    // プライベートブラウジングや容量不足では保存のみ諦める。
  }
}

export function loadCanvasTimerVolume(): number {
  try {
    const raw = window.localStorage.getItem(VOLUME_KEY);
    if (raw === null) return DEFAULT_VOLUME;
    const volume = Number(raw);
    return Number.isFinite(volume) && volume >= 0 && volume <= 1 ? volume : DEFAULT_VOLUME;
  } catch {
    return DEFAULT_VOLUME;
  }
}

export function saveCanvasTimerVolume(volume: number): void {
  try {
    window.localStorage.setItem(VOLUME_KEY, String(clampVolume(volume)));
  } catch {
    // プライベートブラウジングや容量不足では保存のみ諦める。
  }
}

export function clampVolume(volume: number): number {
  if (!Number.isFinite(volume)) return DEFAULT_VOLUME;
  return Math.min(1, Math.max(0, volume));
}
